import { createFileRoute } from "@tanstack/react-router";

import Cart from "@/pages/cart";

export const Route = createFileRoute("/cart/$id")({
  component: CartPage,
  head: () => ({ meta: [{ title: "Review and pay" }] }),
});

function CartPage() {
  return <Cart />;
}
